var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGettingMemberInfo)?_c('Spinner'):_c('div',{staticClass:"flex flex-col justify-between"},[_c('div',{staticClass:"mx-auto w-full max-w-3xl py-20 bg-white"},[_c('h1',{staticClass:"h2"},[_vm._v(_vm._s(_vm.disclaimer.name))]),_c('Markdown',{attrs:{"source":_vm.disclaimer.text}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }